import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import Link from 'src/components/link'
import Picture from 'src/components/picture'
import Button from 'src/components/button'
import Burger from 'src/components/burger'
import CartDrawer from 'src/components/cart-drawer'
import { useStore } from 'src/state'

const Header = () => {
  const {
    toggleNav,
    shouldShowNav,
    headerSlideDuration,
    isScrolled,
    isBrowser,
    setHeaderMenuHeight,
    toggleCart,
    checkout,
    header: { logo, cartButtonText, links = [] },
  } = useStore()

  const [currentLinkId, setCurrentLinkId] = useState(null)
  const [subnavHeight, setSubnavHeight] = useState(0)
  const menuRef = useRef()
  if (!shouldShowNav && currentLinkId) setCurrentLinkId(null)
  useEffect(() => {
    const height = menuRef.current.offsetHeight
    setHeaderMenuHeight(height)
  }, [setHeaderMenuHeight])
  const hasItemsInCart = checkout && checkout.lineItems.length > 0
  const cartTextWithCount = hasItemsInCart
    ? `${cartButtonText} [${checkout.totalQuantity}]`
    : cartButtonText
  return (
    <header
      className={classNames(
        'header',
        shouldShowNav && 'is-open',
        isScrolled && 'is-scrolled'
      )}
    >
      <div className="gradient-background" />
      <div className="menu" ref={menuRef}>
        <div className="menu-start">
          <Button className="modal-btn" onClick={toggleNav}>
            <Burger active={shouldShowNav} />
          </Button>
        </div>
        <div className="menu-middle">
          <Link className="logo" to="/">
            <Picture defaultWidth={500} image={logo} contain fitWidth />
          </Link>
        </div>
        <div className="menu-end">
          <Button className="cart-btn" onClick={toggleCart}>
            {cartTextWithCount}
          </Button>
        </div>
      </div>
      <div
        className="modal"
        style={{
          transitionDuration: `${headerSlideDuration}s`,
        }}
      >
        <div className="images">
          {links.map(
            ({ id, image }) =>
              image && (
                <div
                  key={id}
                  className={classNames(
                    'image',
                    id === currentLinkId && 'active'
                  )}
                >
                  <div className="shadow" />
                  <Picture defaultWidth={1000} image={image} fitWidth cover />
                </div>
              )
          )}
        </div>
        <nav className="nav">
          {links.map(({ id, title, url, image, subnav, newTab }, i) => (
            <Button
              key={id}
              className={classNames(
                'nav-item',
                id === currentLinkId && 'active',
                currentLinkId && id !== currentLinkId && 'inactive',
                subnav && 'has-subnav'
              )}
              style={{
                transitionDelay: `${i * 0.015}s`,
              }}
              onMouseEnter={() => {
                if (isBrowser) {
                  const node = document.querySelector(`.subnav-items-${id}`)
                  setSubnavHeight(node ? node.offsetHeight : 0)
                }
                setCurrentLinkId(id)
              }}
              onMouseLeave={() => setCurrentLinkId(null)}
            >
              <Link className="main-link" to={url} newTab={newTab}>
                {title}
              </Link>
              {subnav && (
                <div className="subnav">
                  <div
                    className="subnav-shim"
                    style={{
                      height: currentLinkId === id ? subnavHeight : 0,
                    }}
                  />
                  <div className={`subnav-items subnav-items-${id}`}>
                    {subnav.map(({ id, title, url }, i) => (
                      <Link className="subnav-link" key={id} to={url}>
                        {title}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </Button>
          ))}
        </nav>
      </div>
      <CartDrawer />
    </header>
  )
}

export default Header
